import { render, staticRenderFns } from "./zhongShanQuestionnaireDetailBack.vue?vue&type=template&id=37dcc09c&scoped=true"
import script from "./zhongShanQuestionnaireDetailBack.vue?vue&type=script&lang=js"
export * from "./zhongShanQuestionnaireDetailBack.vue?vue&type=script&lang=js"
import style0 from "./zhongShanQuestionnaireDetailBack.vue?vue&type=style&index=0&id=37dcc09c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dcc09c",
  null
  
)

export default component.exports